// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"848e7485","462":"507dc284","787":"f764a159"}[chunkId] + ".chunk.js";
};